<div
    *ngIf="files.length > 0 && viewMode === ViewMode.GRID"
    class="grid mt-2 gap-3 grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 2xl:grid-cols-12"
>
    <div
        *ngFor="let file of files"
        class="group relative flex flex-col items-center justify-center
               h-[92px] px-2 py-2 rounded-xl text-center
               border border-transparent
               transition-all duration-200"
        [ngClass]="{
            'hover:bg-white dark:hover:bg-surface-800 hover:border-surface-200 dark:hover:border-surface-700 hover:shadow-sm cursor-pointer':
                file.status !== 'PENDING_UPLOAD' && file.retryCount < 3,
            'border-primary-500 shadow-sm': isSelected(file),
            'cursor-not-allowed opacity-70':
                file.status === 'PENDING_UPLOAD' || file.retryCount >= 3
        }"
        [pTooltip]="getFileSize(file)"
        tooltipPosition="bottom"
        (click)="onCardClick(file)"
        (contextmenu)="onFileContextMenu($event, file, fileMenu)"
    >
        <label class="absolute top-2 left-2 z-10 inline-flex items-center justify-center w-6 h-6 rounded-lg border border-surface-200 bg-surface-0 dark:bg-surface-900" (click)="$event.stopPropagation()">
            <input
                type="checkbox"
                class="form-checkbox h-4 w-4 text-primary-600"
                [checked]="isSelected(file)"
                (change)="toggleFileSelection(file, $any($event.target).checked)"
            />
        </label>
        <!-- ÍCONE -->
        <div
            class="flex items-center justify-center
                   w-10 h-10 rounded-lg
                   bg-surface-50 dark:bg-surface-800/50
                   mb-1.5"
        >
            <i
                class="material-icons text-[22px]"
                [ngClass]="getFileTypeColor(file.contentType)"
            >
                {{ getFileIcon(file.contentType) }}
            </i>

            <!-- STATUS -->
            <span
                *ngIf="file.status === 'PENDING_UPLOAD'"
                class="absolute bottom-0 right-0"
            >
                <i
                    class="pi pi-spin pi-sync text-primary-500 text-sm"
                ></i>
            </span>

            <span
                *ngIf="file.retryCount >= 3"
                class="absolute bottom-0 right-0"
            >
                <i
                    class="pi pi-times-circle text-red-500 text-sm"
                ></i>
            </span>
        </div>

        <!-- NOME -->
        <div class="mt-4 w-full">
            @if (editingFileId === file.id) {

                <input
                    #renameInput
                    pInputText
                    [attr.data-file-id]="file.id"
                    [(ngModel)]="renameValue"
                    class="w-full px-3 py-2 text-sm text-center min-h-[38px]"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                    (keydown.enter)="confirmRename(file)"
                    (keydown.escape)="cancelRename()"
                    (blur)="confirmRename(file)"
                />

            } @else {

                <div
                    class="text-xs text-center
                           text-surface-900 dark:text-surface-0
                           break-words line-clamp-2"
                >
                    {{ getNormalizedFileName(file.name) }}
                </div>

            }
        </div>
    </div>
</div>

<!-- LIST -->
<div *ngIf="viewMode === ViewMode.LIST" class="bg-white dark:bg-surface-900 rounded-xl overflow-hidden shadow-sm">
    <div
        *ngFor="let file of files"
        class="group px-4 py-3 flex items-center gap-4 border-b last:border-0 border-surface-100 dark:border-surface-800 transition-all duration-200"
        [ngClass]="{
            'hover:bg-surface-50 dark:hover:bg-surface-800/50 cursor-pointer': file.status !== 'PENDING_UPLOAD' && file.retryCount < 3,
            'border-primary-500 bg-blue-50 dark:bg-blue-950': isSelected(file),
            'opacity-60 cursor-wait': file.status === 'PENDING_UPLOAD' || file.retryCount >= 3
        }"
        (click)="onCardClick(file)"
        (contextmenu)="onFileContextMenu($event, file, fileMenu)"
    >
        <div class="flex items-center">
            <input
                type="checkbox"
                class="form-checkbox h-4 w-4 text-primary-600"
                [checked]="isSelected(file)"
                (click)="$event.stopPropagation()"
                (change)="toggleFileSelection(file, $any($event.target).checked)"
            />
        </div>
        <!-- ICON -->
        <div class="relative">
            <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-surface-50 dark:bg-surface-800/50">
                <i class="material-icons text-[20px]" [ngClass]="getFileTypeColor(file.contentType)" [class.animate-spin]="file.status === 'PENDING_UPLOAD' && file.retryCount < 3">
                    {{ getFileIcon(file.contentType) }}
                </i>
            </div>

            <span *ngIf="file.retryCount >= 3" class="absolute -bottom-1 -right-1 w-4 h-4 rounded-full bg-red-500 border-2 border-white dark:border-surface-900 flex items-center justify-center">
                <i class="material-icons text-[8px] text-white"> close </i>
            </span>
        </div>

        <!-- INFO -->
        <div class="flex-grow min-w-0">
            @if (editingFileId === file.id) {

                <input
                    #renameInput
                    pInputText
                    [attr.data-file-id]="file.id"
                    [(ngModel)]="renameValue"
                    class="w-full px-3 py-2 text-sm text-surface-900 dark:text-surface-0 min-h-[38px]"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                    (keydown.enter)="confirmRename(file)"
                    (keydown.escape)="cancelRename()"
                    (blur)="confirmRename(file)"
                />

            } @else {

                <div class="text-sm font-semibold truncate text-surface-900 dark:text-surface-0">
                    {{ getNormalizedFileName(file.name) }}
                </div>

            }
        </div>

        <!-- RIGHT -->
        <div class="flex flex-col items-end gap-2 min-w-[100px]">
            <div class="flex items-center gap-2 mt-1">
                <span
                    class="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg text-[10px] font-semibold tracking-wide border backdrop-blur-sm transition-all"
                    [ngClass]="{
                        'bg-emerald-500/10 text-emerald-600 border-emerald-500/20 dark:text-emerald-400': file.status === 'UPLOADED',

                        'bg-blue-500/10 text-blue-600 border-blue-500/20 dark:text-blue-400 animate-pulse': file.status === 'PENDING_UPLOAD' && file.retryCount < 3,

                        'bg-orange-500/10 text-orange-600 border-orange-500/20 dark:text-orange-400': file.status === 'ERROR' && file.retryCount < 3,

                        'bg-red-500/10 text-red-600 border-red-500/20 dark:text-red-400': file.retryCount >= 3
                    }"
                >
                    <!-- Ícone -->
                    <i
                        class="pi text-[9px]"
                        [ngClass]="{
                            'pi-check-circle': file.status === 'UPLOADED',

                            'pi-spin pi-sync': file.status === 'PENDING_UPLOAD' && file.retryCount < 3,

                            'pi-exclamation-triangle': file.status === 'ERROR' && file.retryCount < 3,

                            'pi-times-circle': file.retryCount >= 3
                        }"
                    ></i>

                    <!-- Texto -->
                    <ng-container *ngIf="file.retryCount >= 3"> Falha Permanente </ng-container>

                    <ng-container *ngIf="file.status === 'PENDING_UPLOAD' && file.retryCount < 3"> Sincronizando... </ng-container>

                    <ng-container *ngIf="file.status === 'ERROR' && file.retryCount < 3"> Erro {{ file.retryCount }}/3 </ng-container>

                    <ng-container *ngIf="file.status === 'SUCCESS'">
                        <span class="truncate max-w-[180px]">
                            {{ file.lastModified || file.createdAt | date: 'dd/MM/yyyy HH:mm' }}
                        </span>

                        <span class="opacity-50">•</span>

                        <span class="truncate max-w-[90px] font-bold">
                            {{ getUpdateOrCreationBy(file) }}
                        </span>
                    </ng-container>
                </span>
            </div>

            <button *ngIf="file.status === 'ERROR' || file.retryCount >= 3" class="text-[10px] font-bold uppercase text-red-500 hover:text-red-700 transition-colors" (click)="delete(file, $event)" pTooltip="Deletar arquivo">Deletar</button>
        </div>
    </div>
</div>

<p-contextmenu #fileMenu [model]="fileMenuItems"></p-contextmenu>

<!-- EMPTY -->
<div *ngIf="files.length === 0" class="flex flex-col items-center justify-center py-12 text-surface-400">
    <div class="bg-surface-100 dark:bg-surface-800 p-5 rounded-full mb-4">
        <i class="material-icons text-4xl"> insert_drive_file </i>
    </div>

    <p class="text-sm font-medium text-surface-500">Nenhum arquivo encontrado neste diretório</p>
</div>
